import {
  type EventsPageEntity,
  type EventsTotalsEntity,
  type ComparedValueEntity,
  EventItemEntity
} from '../../data/entities/events.entity'
import { type EventsResponse, type ComparedValue, type EventsSummary, type EventItem } from '../models/events'

export class CombinedEventsToResponseMapper {
  public map(from: { page: EventsPageEntity; totals: EventsTotalsEntity }): EventsResponse {
    return {
      summary: this.mapSummary(from.totals),
      items: from.page.items.map((item) => this.mapItem(item)),
      total: from.page.total
    }
  }

  private mapSummary(from: EventsTotalsEntity): EventsSummary {
    return {
      buyNowClicks: this.mapComparedValue(from.buy_now_clicks),
      presaleCodes: this.mapComparedValue(from.presale_codes),
      meetAndGreet: this.mapComparedValue(from.meet_and_greet),
      vip: this.mapComparedValue(from.vip),
      rsvp: this.mapComparedValue(from.rsvp)
    }
  }

  private mapItem(from: EventItemEntity): EventItem {
    return {
      event: from.event,
      city: from.city,
      numEvents: from.num_events,
      buyNowClicks: this.mapComparedValue(from.buy_now_clicks),
      presaleCodes: this.mapComparedValue(from.presale_codes),
      meetAndGreet: this.mapComparedValue(from.meet_and_greet),
      vip: this.mapComparedValue(from.vip),
      rsvp: this.mapComparedValue(from.rsvp)
    }
  }

  private mapComparedValue(from: ComparedValueEntity): ComparedValue {
    return {
      current: from.current,
      previous: from.previous,
      diff: from.diff
    }
  }
}
